<!-- @format -->

<div *transloco="let t" class="container">
  @if (studentWorkflow) {
    <div class="row gy-4">
      @if (isWorkflowRequestedOrInHandling()) {
        <div class="col-12 d-flex justify-content-end">
          <fudis-button
            [label]="t('STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.CANCEL_APPLICATION')"
            (handleClick)="openCancelDialog()"
            [variant]="'primary'"
            data-cy="dpaw-cancel-button" />
        </div>
      }
      @if (isWorkflowCancelled()) {
        <div class="col-12">
          <fudis-notification [variant]="'warning'">
            <fudis-body-text>
              {{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.APPLICATION_CANCELLED") }}
            </fudis-body-text>
          </fudis-notification>
        </div>
      }
      @if (isWorkflowRequestedOrInHandling()) {
        <div class="col-12">
          <fudis-notification [variant]="'info'">
            <fudis-body-text>
              @if (studentWorkflow.moduleId | module | async; as degreeProgramme) {
                <transloco
                  [params]="{ degreeProgrammeName: degreeProgramme.name | localizedString }"
                  key="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.APPLICATION_REQUESTED"></transloco>
              }
            </fudis-body-text>
          </fudis-notification>
        </div>
      }
      @if (isWorkflowRejected()) {
        <sis-contextual-notification [variant]="'danger'">
          <p>
            @if (studentWorkflow.moduleId | module | async; as degreeProgramme) {
              <transloco
                [params]="{ degreeProgrammeName: degreeProgramme.name | localizedString }"
                key="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.APPLICATION_REJECTED"></transloco>
            }
          </p>
          <p>{{ getResolutionRationale() }}</p>
        </sis-contextual-notification>
      }
      @if (isWorkflowAcceptanceRevoked()) {
        @if (latestAttainment$ | async; as attainment) {
          <sis-contextual-notification [variant]="'danger'">
            <p>
              @if (studentWorkflow.moduleId | module | async; as degreeProgramme) {
                <transloco
                  [params]="{ degreeProgrammeName: degreeProgramme.name | localizedString }"
                  key="STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.APPLICATION_ACCEPTANCE_REVOKED"></transloco>
              }
            </p>
            <p>{{ attainment.misregistrationRationale }}</p>
          </sis-contextual-notification>
        }
      }
      @if (latestAttainment$ | async; as attainment) {
        <div class="col-12 d-flex justify-content-end">
          <app-degree-certificate-download [degreeProgrammeAttainmentId]="attainment.id" />
        </div>
      }
      <div class="col-12">
        <h2>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.PERSON_INFO.TITLE") }}</h2>
        <sis-person-info-for-graduation [person]="studentWorkflow.studentId | privatePerson | async"></sis-person-info-for-graduation>
      </div>
      <div class="col-12">
        <h2>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.CONTACT_INFO.TITLE") }}</h2>
        <sis-contact-info-for-graduation
          [level]="3"
          [person]="studentWorkflow.studentId | privatePerson | async"></sis-contact-info-for-graduation>
      </div>
      @if (shouldShowOtherInfo()) {
        <div class="col-12">
          <h2>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.OTHER_INFO.TITLE") }}</h2>
          @if (studentWorkflow.questionnaireAnswers) {
            <sis-degree-programme-attainment-application-answers
              [workflow]="studentWorkflow"></sis-degree-programme-attainment-application-answers>
          }
          @if (studentWorkflow.additionalInfo) {
            <h3>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.OTHER_INFO.ADDITIONAL_INFO") }}</h3>
            <p>{{ studentWorkflow.additionalInfo }}</p>
          }
        </div>
      }
      <div class="col-12">
        <h2>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.TITLE") }}</h2>
        @if (isDeliveryByPickUp()) {
          <p><transloco [key]="'STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.PICK_UP_INFO'" /></p>
        }
        @if (isDeliveryByMail()) {
          <p><transloco [key]="'STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.MAIL_INFO'" /></p>
        }
        @if (isDigitalDegreeCertificatePreferred()) {
          <p
            ><transloco [key]="'STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.DEGREE_DELIVERY.DIGITAL_DEGREE_CERTIFICATE'"
          /></p>
        }
      </div>
      @if (isDeliveryByMail()) {
        <div class="col-12">
          @if (isDeliveryAddressInFinland()) {
            <span>{{ getStreetAddress() }}, </span>
            <span>{{ getPostalCode() }}, </span>
            <span>{{ getCity() }}, </span>
          }
          @if (!isDeliveryAddressInFinland()) {
            <span>{{ getAddress() }}, </span>
          }
          <span>{{ studentWorkflow.deliveryAddress?.countryUrn | codeLocalizedName | async }}</span>
        </div>
      }
      @if (shouldShowAlumniAssociationInfo()) {
        <div class="col-12">
          <h2>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.ALUMNI_ASSOCIATION.TITLE") }}</h2>
          @if (studentWorkflow.joinsAlumniAssociation) {
            <div>
              <p>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.ALUMNI_ASSOCIATION.JOINED") }}</p>
              <p>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.ALUMNI_ASSOCIATION.TRANSFERRED_INFOS") }}</p>
            </div>
          }
          @if (!studentWorkflow.joinsAlumniAssociation) {
            <div>
              <p>{{ t("STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.ALUMNI_ASSOCIATION.NOT_JOINED") }}</p>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
